import React from 'react';
import { BookOpen } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const ConsultationPage = () => {
  const serviceData = {
    icon: BookOpen,
    nameAr: 'دائرة الدراسات والاستشارات',
    nameEn: 'Studies and Consultation Department',
    taglineAr: 'استشارات قانونية متخصصة ودراسات قانونية معمقة',
    taglineEn: 'Specialized legal consultations and in-depth legal studies',
    
    descriptionAr: [
      'تقدم دائرة الدراسات والاستشارات في وازن خدمات استشارية قانونية متكاملة للأفراد والشركات. نعتمد على فريق من المستشارين القانونيين ذوي الخبرة الواسعة في تقديم الرأي القانوني السديد والمبني على أسس نظامية قوية.',
      'نحرص على تقديم استشارات دقيقة وشاملة تساعد عملاءنا على اتخاذ القرارات الصحيحة وتجنب المخاطر القانونية المحتملة.'
    ],
    descriptionEn: [
      'Wazin\'s Studies and Consultation Department provides comprehensive legal advisory services to individuals and companies. We rely on a team of legal consultants with extensive experience in providing sound legal opinions based on strong regulatory foundations.',
      'We are committed to providing accurate and comprehensive consultations that help our clients make correct decisions and avoid potential legal risks.'
    ],

    services: [
      {
        nameAr: 'تقديم الاستشارات القانونية المكتوبة المفصلة',
        nameEn: 'Providing detailed written legal consultations',
        descAr: 'إعداد استشارات قانونية شاملة ومكتوبة مدعومة بالنصوص النظامية والمراجع القانونية',
        descEn: 'Preparing comprehensive written legal consultations supported by regulatory texts and legal references'
      },
      {
        nameAr: 'تقديم الاستشارات القانونية الشفوية/الهاتفية/الأونلاين',
        nameEn: 'Providing oral/phone/online legal consultations',
        descAr: 'تقديم استشارات قانونية مباشرة عبر الاجتماعات الشخصية أو الهاتفية أو المنصات الإلكترونية',
        descEn: 'Providing direct legal consultations through personal meetings, phone calls, or electronic platforms'
      },
      {
        nameAr: 'إعداد الدراسات القانونية المتخصصة حول موضوعات محددة',
        nameEn: 'Preparing specialized legal studies on specific topics',
        descAr: 'إجراء دراسات قانونية معمقة ومتخصصة لموضوعات أو مشاريع محددة',
        descEn: 'Conducting in-depth specialized legal studies for specific topics or projects'
      },
      {
        nameAr: 'تحليل المخاطر القانونية المرتبطة بنشاط العميل',
        nameEn: 'Analyzing legal risks related to client activities',
        descAr: 'تقييم شامل للمخاطر القانونية المحتملة المرتبطة بأنشطة العميل ووضع خطط للتعامل معها',
        descEn: 'Comprehensive assessment of potential legal risks related to client activities and developing plans to address them'
      },
      {
        nameAr: 'إعداد الرأي القانوني (Legal Opinion) المعتمد',
        nameEn: 'Preparing certified Legal Opinion',
        descAr: 'إصدار رأي قانوني رسمي ومعتمد موثق من مستشارين قانونيين مرخصين',
        descEn: 'Issuing official certified legal opinion documented by licensed legal consultants'
      },
      {
        nameAr: 'مراجعة القرارات واللوائح الداخلية من منظور نظامي',
        nameEn: 'Reviewing internal decisions and regulations from legal perspective',
        descAr: 'فحص ومراجعة القرارات والسياسات الداخلية للشركات للتأكد من توافقها مع الأنظمة',
        descEn: 'Examining and reviewing internal company decisions and policies to ensure compliance with regulations'
      },
      {
        nameAr: 'تحليل الأنظمة واللوائح السعودية ذات العلاقة بنشاط العميل',
        nameEn: 'Analyzing Saudi regulations related to client activities',
        descAr: 'دراسة وتحليل الأنظمة واللوائح السعودية المرتبطة بنشاط العميل وتقديم التوصيات',
        descEn: 'Studying and analyzing Saudi regulations related to client activities and providing recommendations'
      },
      {
        nameAr: 'تقديم استشارات عاجلة وفورية في الحالات الحرجة',
        nameEn: 'Providing urgent and immediate consultations in critical cases',
        descAr: 'تقديم استشارات قانونية سريعة وفورية للحالات التي تتطلب اتخاذ قرار عاجل',
        descEn: 'Providing quick immediate legal consultations for cases requiring urgent decisions'
      },
      {
        nameAr: 'تقديم باقات استشارية شهرية وسنوية للشركات والجهات',
        nameEn: 'Providing monthly and annual consultation packages for companies',
        descAr: 'توفير باقات استشارية متكاملة بنظام الاشتراك الشهري أو السنوي للشركات والمؤسسات',
        descEn: 'Providing comprehensive consultation packages with monthly or annual subscription system for companies and institutions'
      }
    ],

    specializations: [
      { ar: 'استشارات الشركات والأعمال', en: 'Corporate and Business Consultations' },
      { ar: 'الاستشارات العقارية', en: 'Real Estate Consultations' },
      { ar: 'الاستشارات العمالية', en: 'Labor Consultations' },
      { ar: 'الاستشارات التجارية', en: 'Commercial Consultations' },
      { ar: 'استشارات الملكية الفكرية', en: 'Intellectual Property Consultations' },
      { ar: 'الاستشارات الضريبية', en: 'Tax Consultations' },
      { ar: 'استشارات الاستثمار', en: 'Investment Consultations' },
      { ar: 'الاستشارات الأسرية', en: 'Family Consultations' },
      { ar: 'استشارات الامتثال', en: 'Compliance Consultations' },
      { ar: 'استشارات التقاضي', en: 'Litigation Consultations' }
    ],

    faqs: [
      {
        questionAr: 'ما الفرق بين الاستشارة والتمثيل القانوني؟',
        questionEn: 'What is the difference between consultation and legal representation?',
        answerAr: 'الاستشارة هي تقديم الرأي القانوني والتوجيه بشأن موضوع معين، بينما التمثيل القانوني يشمل المرافعة والحضور أمام المحاكم والجهات الرسمية نيابة عن العميل.',
        answerEn: 'Consultation is providing legal opinion and guidance on a specific matter, while legal representation includes pleading and appearing before courts and official bodies on behalf of the client.'
      },
      {
        questionAr: 'هل الاستشارة الأولى مجانية؟',
        questionEn: 'Is the first consultation free?',
        answerAr: 'نعم، نقدم استشارة أولية مجانية لتقييم احتياجاتكم القانونية وتحديد أفضل الحلول الممكنة.',
        answerEn: 'Yes, we provide a free initial consultation to assess your legal needs and determine the best possible solutions.'
      },
      {
        questionAr: 'كم يستغرق الحصول على الرد الاستشاري؟',
        questionEn: 'How long does it take to receive a consultation response?',
        answerAr: 'للاستشارات العاجلة نقدم الرد خلال 24 ساعة، أما الاستشارات المعقدة التي تتطلب دراسة معمقة فقد تستغرق من 3 إلى 7 أيام عمل.',
        answerEn: 'For urgent consultations, we provide a response within 24 hours, while complex consultations requiring in-depth study may take 3 to 7 business days.'
      },
      {
        questionAr: 'هل يمكن الحصول على استشارة أونلاين؟',
        questionEn: 'Can I get an online consultation?',
        answerAr: 'نعم، نوفر خدمة الاستشارات القانونية عبر الإنترنت من خلال الاجتماعات المرئية أو الكتابية عبر منصتنا الإلكترونية.',
        answerEn: 'Yes, we provide online legal consultation services through video meetings or written consultations via our electronic platform.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default ConsultationPage;